import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { globalMessages } from '../global-messages';

@Pipe({
    name: 'formattedValue',
    standalone: true,
})
export class FormattedValuePipe implements PipeTransform {
    private datePipe = new DatePipe('en-US');

    transform(value: any, fieldName: string): string | null {
        if (value == null) {
            return '';
        } else if (globalMessages.currencyFields.includes(fieldName)) {
            const num = parseFloat(String(value).replace(/,/g, ''));
            if (isNaN(num)) return `$${value}`;
            const abs = Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            return num < 0 ? `-$${abs}` : `$${abs}`;
        } else if (globalMessages.dateFields.includes(fieldName)) {
            return this.datePipe.transform(value, 'MM/dd/yyyy');
        } else if (globalMessages.lobFields.includes(fieldName)) {
            return this.getProductName(value);
        }
        return value;
    }

    formatDateOnly(value: any): string {
        if (value == null) return '-';
        const date = new Date(value);
        if (isNaN(date.getTime())) return value;
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${m}/${d}/${y}`;
    }

    transformDate(value: any): string | null {
        if (value == null) {
            return '-';
        }
        return this.datePipe.transform(value, 'MM/dd/yyyy');
    }

    formatPhone(value: any): string {
        if (!value) return '';
        const digits = String(value).replace(/\D/g, '');
        if (digits.length !== 10) return String(value);
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6)}`;
    }

    transformCurrency(value: any): string | null {
        if (value == null || value === '') return '$0.00';
        const num = parseFloat(String(value).replace(/,/g, ''));
        if (isNaN(num)) return `$${value}`;
        const abs = Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return num < 0 ? `-$${abs}` : `$${abs}`;
    }

    getProductName(type: string): string {
        let productName;
        switch (type) {
            case 'HO3':
                productName = 'Homeowners';
                break;
            case 'HO4':
                productName = 'Renters';
                break;
            case 'HO6':
                productName = 'Condo';
                break;
            case 'DP1':
                productName = 'Basic Dwelling';
                break;
            case 'DP3':
                productName = 'Special Dwelling';
                break;
            case 'Street':
                productName = 'Motorcycle Street';
                break;
            case 'OffRoad':
                productName = 'Motorcycle Off-road';
                break;
            case 'MCST':
                productName = 'Motorcycle';
                break;
            case 'MCOR':
                productName = 'Motorcycle Off-road';
                break;
            case 'PB':
                productName = 'Boat';
                break;
            case 'PleasureBoat':
                productName = 'Boat';
                break;
            case 'PWC':
                productName = 'Watercraft';
                break;
            case 'MH':
                productName = 'Manufactured Home';
                break;
            case 'CPL':
                productName = 'Personal Liability';
                break;
            case 'PUP':
                productName = 'Personal Umbrella';
                break;
            case 'EQ':
                productName = 'Earthquake';
                break;
            default:
                productName = type;
                break;
        }
        return productName;
    }
}
